export class Config {
	static readonly CODE_LENGTH = 8;
	static readonly EXCLUDED_CHARS = ['0', '1', 'O', 'I', 'B', '8'];
	static readonly VERSION = '2.1.1';

	// wait for x milliseconds to execute full-text search
	static readonly SEARCH_DELAY = 1000;

	static readonly SEARCH_SELECT_MINIMUM_INPUT_LENGTH = 3;
}
